import { useEffect } from "react"

export default function useTitle({ title = 'Inicio' }) {


    useEffect(() => {
        document.title = `${title} | Facturar PA`;

    }, [title])

}